import {takeEvery} from 'redux-saga/effects';
import {addCardActions} from "./addCard.slice";
import {addImageSaga} from "./_sagas/addImage.saga";
import {uploadCardSaga} from "./_sagas/uploadCard.saga";

export function* addCardSaga() {
    yield takeEvery(addCardActions.addImage.type, addImageSaga);
    yield takeEvery(addCardActions.uploadCard.type, uploadCardSaga);
}
